/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Export_Item_HealthInputs */

const en_us2_profile_editors_export_item_health = /** @type {(inputs: Profile_Editors_Export_Item_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pain, injuries, equipment and the health questionnaire`)
};

const pt_br2_profile_editors_export_item_health = /** @type {(inputs: Profile_Editors_Export_Item_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dores, lesões, equipamentos e questionário de saúde`)
};

const es_419_profile_editors_export_item_health = /** @type {(inputs: Profile_Editors_Export_Item_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolores, lesiones, equipo y el cuestionario de salud`)
};

const pt_pt2_profile_editors_export_item_health = /** @type {(inputs: Profile_Editors_Export_Item_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dores, lesões, equipamento e questionário de saúde`)
};

const fr_fr2_profile_editors_export_item_health = /** @type {(inputs: Profile_Editors_Export_Item_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Douleurs, blessures, matériel et questionnaire de santé`)
};

const de_de2_profile_editors_export_item_health = /** @type {(inputs: Profile_Editors_Export_Item_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schmerzen, Verletzungen, Ausrüstung und der Gesundheitsfragebogen`)
};

const it_it2_profile_editors_export_item_health = /** @type {(inputs: Profile_Editors_Export_Item_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolori, infortuni, attrezzatura e questionario sulla salute`)
};

/**
* | output |
* | --- |
* | "Pain, injuries, equipment and the health questionnaire" |
*
* @param {Profile_Editors_Export_Item_HealthInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_export_item_health = /** @type {((inputs?: Profile_Editors_Export_Item_HealthInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Export_Item_HealthInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_export_item_health(inputs)
	if (locale === "es-419") return es_419_profile_editors_export_item_health(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_export_item_health(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_export_item_health(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_export_item_health(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_export_item_health(inputs)
	return en_us2_profile_editors_export_item_health(inputs)
});
export { profile_editors_export_item_health as "profile-editors.export_item_health" }